import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../useWindowDimensions";

const CardSlider = ({ data, Card, endValues }) => {
  const { width } = useWindowDimensions();
  const { sm, md, lg, xs } = endValues;
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(3);
  const [eventData, setEventData] = useState([]);
  const [showRight, setShowRight] = useState(false);
  const [showLeft, setShowLeft] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    let endValue;
    if (width >= 991) {
      endValue = lg;
    } else if (width >= 640) {
      endValue = md;
    } else if (width >= 400 && sm) {
      endValue = sm;
    } else {
      endValue = xs;
    }

    setEnd(start + endValue);
    const tempData = data.slice(start, start + endValue);
    setEventData(tempData);

    setShowLeft(start > 0);
    setShowRight(start + endValue < data.length);
  }, [width, start, data, sm, md, lg, xs]);

  const handleRight = () => {
    if (end < data.length && !isTransitioning) {
      setIsTransitioning(true);
      setTimeout(() => {
        setStart(start + 1);
        setIsTransitioning(false);
      }, 150);
    }
  };

  const handleLeft = () => {
    if (start > 0 && !isTransitioning) {
      setIsTransitioning(true);
      setTimeout(() => {
        setStart(start - 1);
        setIsTransitioning(false);
      }, 150);
    }
  };

  return (
    <div className="relative">
      {/* Cards Container with consistent sizing and sliding animation */}
      <div className="flex gap-3 overflow-hidden">
        <div 
          className={`flex gap-3 transition-transform duration-500 ease-out my-3 ${
            isTransitioning ? 'transform translate-x-4' : 'transform translate-x-0'
          }`}
          style={{
            display: 'flex',
            alignItems: 'stretch' // This ensures all cards stretch to the same height
          }}
        >
          {eventData.map((item, index) => (
            <div 
              key={`${start}-${index}`} 
              className="flex-shrink-0"
              style={{
                width: `calc((100% - ${(eventData.length - 1) * 0.75}rem) / ${eventData.length})`,
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Card item={item} />
            </div>
          ))}
        </div>
      </div>

      {/* Right Arrow */}
      {showRight && (
        <button
          onClick={handleRight}
          disabled={isTransitioning}
          className="next-btn absolute top-1/3 transform -translate-y-1/2 right-2 xs:right-3 sm:right-4 text-white bg-[#10c9c0] opacity-75 hover:opacity-100 rounded p-[0.5rem] hover:pl-[1rem] hover:translate-x-[0.5rem] transition-all duration-300 text-[20px] disabled:opacity-50 disabled:cursor-not-allowed z-10"
        >
          &#10095;
        </button>
      )}

      {/* Left Arrow */}
      {showLeft && (
        <button
          onClick={handleLeft}
          disabled={isTransitioning}
          className="prev-btn absolute top-1/3 transform -translate-y-1/2 left-2 xs:left-3 sm:left-4 text-white bg-[#10c9c0] opacity-75 hover:opacity-100 rounded p-[0.5rem] hover:pr-[1rem] hover:translate-x-[-0.5rem] transition-all duration-300 text-[20px] disabled:opacity-50 disabled:cursor-not-allowed z-10"
        >
          &#10094;
        </button>
      )}
    </div>
  );
};

export default CardSlider;